import { IControllerConstructor } from "angular";
import * as FulfilmentRoutes from './fulfilment.routes';
import { FulfilmentDashboardController } from "./fulfilment-dashboard/fulfilment-dashboard.controller";
import { FulfilmentRequestsController } from "./fulfilment-requests/fulfilment-requests.controller";
import { FulfilmentRequestController } from "./fulfilment-request/fulfilment-request.controller";
import { FulfilmentRequestSummaryController } from "./fulfilment-request/summary/fulfilment-request-summary.controller";
import { FulfilmentRequestTimelineController } from "./fulfilment-request/timeline/fulfilment-request-timeline.controller";
import { FulfilmentRequestDetailsController } from "./fulfilment-request/details/fulfilment-request-details.controller";


export const initialise = function () {
  angular
    .module('actora.fulfilment', [
      'pascalprecht.translate',
      'actora.services',
      'app.layout',
      'app.components',

      'ui.router.upgrade'
    ])
    .controller('FulfilmentDashboardController', <IControllerConstructor>FulfilmentDashboardController)
    .controller('FulfilmentRequestsController', <IControllerConstructor>FulfilmentRequestsController)
    .controller('FulfilmentRequestController', <IControllerConstructor>FulfilmentRequestController)
    .controller('FulfilmentRequestSummaryController', <IControllerConstructor>FulfilmentRequestSummaryController)
    .controller('FulfilmentRequestDetailsController', <IControllerConstructor>FulfilmentRequestDetailsController)
    .controller('FulfilmentRequestTimelineController', <IControllerConstructor>FulfilmentRequestTimelineController)
    .constant('fulfilmentStatuses', {
      positive: {
        'FULFILMENT_REQUEST_SUCCESSFUL': 'FULFILMENT_REQUEST_SUCCESSFUL',
        'FULFILMENT_REQUEST_ACCEPTED': 'FULFILMENT_REQUEST_ACCEPTED',
        'FULFILMENT_REQUEST_DISTRIBUTED': 'FULFILMENT_REQUEST_DISTRIBUTED',
        'FULFILMENT_REQUEST_RECEIVED': 'FULFILMENT_REQUEST_RECEIVED',
        'ACTIONLIST_ITEM_CONSTRUCTED': 'ACTIONLIST_ITEM_CONSTRUCTED',
        'ACTIONLIST_ITEM_COLLECTED': 'ACTIONLIST_ITEM_COLLECTED',
        'ACTIONLIST_ITEM_DISTRIBUTED': 'ACTIONLIST_ITEM_DISTRIBUTED',
        'ACTIONLIST_ITEM_LIVE': 'ACTIONLIST_ITEM_LIVE',
        'ACTIONLIST_ITEM_PRODUCT_MATCHED': 'ACTIONLIST_ITEM_PRODUCT_MATCHED',
        'ACTIONLIST_ITEM_CANCELLATION_SUCCESSFUL': 'ACTIONLIST_ITEM_CANCELLATION_SUCCESSFUL',
        'ACTIONLIST_ADDITIONAL_LOCATIONS_DISTRIBUTED': 'ACTIONLIST_ADDITIONAL_LOCATIONS_DISTRIBUTED',
        'HOTLIST_ITEM_CONSTRUCTED': 'HOTLIST_ITEM_CONSTRUCTED',
        'HOTLIST_ITEM_DISTRIBUTED': 'HOTLIST_ITEM_DISTRIBUTED',
        'HOTLIST_ITEM_COLLECTED': 'HOTLIST_ITEM_COLLECTED',
        'HOTLIST_ITEM_LIVE': 'HOTLIST_ITEM_LIVE',
        'HOTLIST_ITEM_CANCELLATION_SUCCESSFUL': 'HOTLIST_ITEM_CANCELLATION_SUCCESSFUL',
        'UPDATE_DISTRIBUTION_ACCEPTED': 'UPDATE_DISTRIBUTION_ACCEPTED',
        'VOID_REQUEST_RECEIVED': 'VOID_REQUEST_RECEIVED',
        'VOID_REQUEST_ACCEPTED': 'VOID_REQUEST_ACCEPTED',
        'VOID_REQUEST_DISTRIBUTED': 'VOID_REQUEST_DISTRIBUTED',
        'VOID_REQUEST_SUCCESSFUL': 'VOID_REQUEST_SUCCESSFUL',
        'CANCELLATION_REQUEST_SUCCESSFUL': 'CANCELLATION_REQUEST_SUCCESSFUL',
        'CANCELLATION_REQUEST_ACCEPTED': 'CANCELLATION_REQUEST_ACCEPTED',
        'DISTRIBUTION_REQUEST_SUCCESSFUL': 'DISTRIBUTION_REQUEST_SUCCESSFUL',
        'DISTRIBUTION_REQUEST_ACCEPTED': 'DISTRIBUTION_REQUEST_ACCEPTED'
      },
      negative: {
        'FULFILMENT_REQUEST_REJECTED': 'FULFILMENT_REQUEST_REJECTED',
        'FULFILMENT_REQUEST_RECEIVED_REJECTED': 'FULFILMENT_REQUEST_RECEIVED_REJECTED',
        'FULFILMENT_REQUEST_REVALIDATE': 'FULFILMENT_REQUEST_REVALIDATE',
        'ACTIONLIST_ITEM_CONSTRUCTION_FAILED': 'ACTIONLIST_ITEM_CONSTRUCTION_FAILED',
        'ACTIONLIST_ITEM_COLLECTION_FAILED_ATTEMPT': 'ACTIONLIST_ITEM_COLLECTION_FAILED_ATTEMPT',
        'ACTIONLIST_ITEM_DISTRIBUTION_FAILED': 'ACTIONLIST_ITEM_DISTRIBUTION_FAILED',
        'ACTIONLIST_ITEM_FAILED': 'ACTIONLIST_ITEM_FAILED',
        'ACTIONLIST_ITEM_CANCELLATION_FAILED': 'ACTIONLIST_ITEM_CANCELLATION_FAILED',
        'HOTLIST_ITEM_CONSTRUCTION_FAILED': 'HOTLIST_ITEM_CONSTRUCTION_FAILED',
        'HOTLIST_ITEM_DISTRIBUTION_FAILED': 'HOTLIST_ITEM_DISTRIBUTION_FAILED',
        'HOTLIST_ITEM_COLLECTION_FAILED_ATTEMPT': 'HOTLIST_ITEM_COLLECTION_FAILED_ATTEMPT',
        'HOTLIST_ITEM_FAILED': 'HOTLIST_ITEM_FAILED',
        'HOTLIST_ITEM_CANCELLATION_FAILED': 'HOTLIST_ITEM_CANCELLATION_FAILED',
        'UPDATE_DISTRIBUTION_REJECTED': 'UPDATE_DISTRIBUTION_REJECTED',
        'VOID_REQUEST_REJECTED': 'VOID_REQUEST_REJECTED',
        'CANCELLATION_REQUEST_RECEIVED_REJECTED': 'CANCELLATION_REQUEST_RECEIVED_REJECTED',
        'CANCELLATION_REQUEST_REJECTED': 'CANCELLATION_REQUEST_REJECTED',
        'DISTRIBUTION_REQUEST_RECEIVED_REJECTED': 'DISTRIBUTION_REQUEST_RECEIVED_REJECTED',
        'DISTRIBUTION_REQUEST_REJECTED': 'DISTRIBUTION_REQUEST_REJECTED'
      },
      neutral: {
        'FULFILMENT_READY_FOR_CONSTRUCTION': 'FULFILMENT_READY_FOR_CONSTRUCTION',
        'FULFILMENT_READY_FOR_DISTRIBUTION': 'FULFILMENT_READY_FOR_DISTRIBUTION',
        'FULFILMENT_REQUEST_HELD': 'FULFILMENT_REQUEST_HELD',
        'ITEM_DISTRIBUTION_RETRY_TIMER': 'ITEM_DISTRIBUTION_RETRY_TIMER',
        'VOID_READY_FOR_CONSTRUCTION': 'VOID_READY_FOR_CONSTRUCTION',
        'VOID_READY_FOR_DISTRIBUTION': 'VOID_READY_FOR_DISTRIBUTION',
        'CANCELLATION_REQUEST_RECEIVED': 'CANCELLATION_REQUEST_RECEIVED',
        'DISTRIBUTION_REQUEST_RECEIVED': 'DISTRIBUTION_REQUEST_RECEIVED',
        'FULFILMENT_REQUEST_CANCELLED': 'FULFILMENT_REQUEST_CANCELLED',
        'FULFILMENT_REQUEST_RECEIVED_CANCELLED': 'FULFILMENT_REQUEST_RECEIVED_CANCELLED',
        'FULFILMENT_REQUEST_UNSUCCESSFUL': 'FULFILMENT_REQUEST_UNSUCCESSFUL',
        'VOID_REQUEST_UNSUCCESSFUL': 'VOID_REQUEST_UNSUCCESSFUL'
      }
    });

  FulfilmentRoutes.initialise();
}
